/**
 * Beside the routes rather than in constants/app-routes.ts only because that file was being
 * edited elsewhere when this area was built; fold these into APP_ROUTES when convenient.
 */
export const ADMIN_PATHS = {
  workflows: {
    list: '/admin/workflows',
    create: '/admin/workflows/new',
    detail: (id: string) => `/admin/workflows/${id}`,
  },
  forms: {
    list: '/admin/forms',
    create: '/admin/forms/new',
    detail: (id: string) => `/admin/forms/${id}`,
  },
  signing: {
    list: '/admin/signing-templates',
    builderNew: '/admin/signing-templates/builder',
    builder: (templateRef: string) => `/admin/signing-templates/builder/${templateRef}`,
  },
  directNdaSettings: '/admin/direct-nda-signer',
  emails: {
    list: '/admin/emails',
    create: '/admin/emails/new',
    detail: (id: string) => `/admin/emails/${id}`,
  },
} as const;
